module.exports = __webpack_public_path__ + "img/flex.f7e34b5b.png";